import React from "react";
import { DataTableDataType, FormatterType, IconFormatter } from "best-common-react";
import { Link } from "react-router";

const IconLinkFormatter = <T extends DataTableDataType>(props: FormatterType<T>) => {
  const { value, rowIndex = -1 } = props;
  return (
    <Link to={value} id={rowIndex.toString()} className="w-100">
      <IconFormatter {...props} />
    </Link>
  );
};

export default IconLinkFormatter;
